__turbopack_context__.v({
  "hitOldPrice": "ProductItem-module-scss-module__kqcm5W__hitOldPrice",
  "item": "ProductItem-module-scss-module__kqcm5W__item",
  "itemContent": "ProductItem-module-scss-module__kqcm5W__itemContent",
  "itemImage": "ProductItem-module-scss-module__kqcm5W__itemImage",
  "itemImageContainer": "ProductItem-module-scss-module__kqcm5W__itemImageContainer",
  "itemPrices": "ProductItem-module-scss-module__kqcm5W__itemPrices",
  "tags": "ProductItem-module-scss-module__kqcm5W__tags",
});
